<div class="overdraft-account-details-component">

  @if (loader.loadingOverdraft.inProgress$ | async) {
    <custom-content-loader type="list"></custom-content-loader>
  }
  @if (!(loader.loadingOverdraft.inProgress$ | async) && pismoAccountAndOpportunityDetails) {
    <div class="row mb-5">
      <div class="col-12">
        <mat-accordion>
          @for (pismoAccountAndOpportunityDetail of pismoAccountAndOpportunityDetails; track pismoAccountAndOpportunityDetail; let isFirstExpansionPanel = $first; let i = $index) {
            <mat-expansion-panel [expanded]="isFirstExpansionPanel">
              <mat-expansion-panel-header>
                <mat-panel-title>Account # {{pismoAccountAndOpportunityDetail.pismoAccountDetails.account_id}}</mat-panel-title>
                <mat-panel-description>Name: {{pismoAccountAndOpportunityDetail.pismoAccountDetails.account_name}} - {{pismoAccountAndOpportunityDetail.pismoAccountDetails.email}}</mat-panel-description>
              </mat-expansion-panel-header>
              <div class="row mb-3">
                <div class="col-12">
                  <div fxLayoutGap="5px"
                    fxLayout="row"
                    fxLayoutAlign="start center"
                    fxLayout.lt-md="column"
                    fxLayoutAlign.lt-md="center start">
                    @if (canEdit) {
                      <button mat-stroked-button color="accent" class="w-lt-md-100" (click)="onCreateNewOverdraftUser(pismoAccountAndOpportunityDetail.pismoAccountDetails.account_id)">
                        <span class="mdi mdi-plus" matPrefix></span> New user
                      </button>
                    }
                    @if (canEdit) {
                      <button mat-stroked-button color="accent" class="w-lt-md-100" (click)="postPismoManualTransaction(pismoAccountAndOpportunityDetail.pismoAccountDetails.account_id)">
                        <span class="mdi mdi-bank" matPrefix></span> Post manual transaction
                      </button>
                    }
                    @if (canEditAccountDetails) {
                      <button mat-stroked-button color="accent" class="w-lt-md-100" (click)="editPismoAccount(pismoAccountAndOpportunityDetail)">
                        <span class="mdi mdi-text-account" matPrefix></span> Change account details
                      </button>
                    }
                    @if (canEdit && pismoAccountAndOpportunityDetail?.pismoAccountDetails?.status !== 'CANCELLED') {
                      <button mat-stroked-button color="accent" class="w-lt-md-100" (click)="onCancelAccount(pismoAccountAndOpportunityDetail)">
                        <span class="mdi mdi-close" matPrefix></span> Account closure
                      </button>
                    }
                    @if (canEdit) {
                      <button mat-stroked-button color="accent" class="w-lt-md-100" (click)="generatePayout(pismoAccountAndOpportunityDetail)">
                        <span class="mdi mdi-cash-refund" matPrefix></span> Generate payout
                      </button>
                    }
                  </div>
                </div>
              </div>
              <div class="row mb-3">
                <div class="col-12">
                  <div fxLayoutGap="5px"
                    fxLayout="row"
                    fxLayoutAlign="start center"
                    fxLayout.lt-md="column"
                    fxLayoutAlign.lt-md="center start">
                    @if (canEdit) {
                      <button mat-stroked-button color="accent" class="w-lt-md-100" (click)="accountActions(pismoAccountAndOpportunityDetail)">
                        <span class="mdi mdi-cog" matPrefix></span> Account Actions
                      </button>
                    }
                    @if (canEdit) {
                      <button mat-stroked-button color="accent" class="w-lt-md-100" (click)="directDebit(pismoAccountAndOpportunityDetail)">
                        <span class="mdi mdi-bank-transfer-out" matPrefix></span> Direct debit
                      </button>
                    }
                    @if (resendOverdraftWelcomeEmailFn && canResendWelcomeEmail) {
                      <button mat-stroked-button color="accent" class="w-lt-md-100"
                        [disabled]="resendWelcomeEmailInProgress"
                        (click)="resendWelcomeEmail(pismoAccountAndOpportunityDetail.pismoAccountDetails.account_id)">
                        <span class="mdi mdi-email-outline" matPrefix></span> Resend welcome email
                      </button>
                    }
                    @if (showDisplayTransactions) {
                      <button mat-stroked-button color="accent" class="w-lt-md-100" (click)="displayPismoAccountTransaction(pismoAccountAndOpportunityDetail.pismoAccountDetails.account_id)">
                        <span class="mdi mdi-bank" matPrefix></span> Display transactions
                      </button>
                    }
                  </div>
                </div>
              </div>
              @if (!canEdit && !canEditAccountDetails) {
                <div class="row">
                  <div class="col-lg-6 col-md-12">
                    <message-box title="Info" type="info">
                      Only Admin, Operations and Analyst can perform edit.
                    </message-box>
                  </div>
                </div>
              }
              <div class="row pismo-account-details">
                <div class="col-lg-3 col-md-12 title">Pismo Account Number</div>
                <div class="col-lg-6 col-md-12">{{pismoAccountAndOpportunityDetail.pismoAccountDetails.account_id}}</div>
              </div>
              <mat-divider></mat-divider>
              <div class="row pismo-account-details">
                <div class="col-lg-3 col-md-12 title">Account Name</div>
                <div class="col-lg-6 col-md-12">{{pismoAccountAndOpportunityDetail.pismoAccountDetails.account_name}}</div>
              </div>
              <mat-divider></mat-divider>
              <div class="row pismo-account-details">
                <div class="col-lg-3 col-md-12 title">Status</div>
                <div class="col-lg-6 col-md-12">{{pismoAccountAndOpportunityDetail.pismoAccountDetails.status}}
                  @if (pismoAccountAndOpportunityDetail.pismoAccountDetails.collections_status === 'OVERDUE') {
                    <span class="ml-1">({{pismoAccountAndOpportunityDetail.pismoAccountDetails.collections_status}})</span>
                  }
                </div>
              </div>
              <mat-divider></mat-divider>
              <div class="row pismo-account-details">
                <div class="col-lg-3 col-md-12 title">Program</div>
                <div class="col-lg-6 col-md-12">{{pismoAccountAndOpportunityDetail.pismoAccountDetails.program_name}}</div>
              </div>
              <mat-divider></mat-divider>
              <div class="row pismo-account-details">
                <div class="col-lg-3 col-md-12 title">Program ID</div>
                <div class="col-lg-6 col-md-12">{{pismoAccountAndOpportunityDetail.pismoAccountDetails.program_id}}</div>
              </div>
              <mat-divider></mat-divider>
              <div class="row pismo-account-details">
                <div class="col-lg-3 col-md-12 title">Email</div>
                <div class="col-lg-6 col-md-12">{{pismoAccountAndOpportunityDetail.pismoAccountDetails.email}}</div>
              </div>
              <mat-divider></mat-divider>
              <div class="row pismo-account-details">
                <div class="col-lg-3 col-md-12 title">Creation Date</div>
                <div class="col-lg-6 col-md-12">{{moment(pismoAccountAndOpportunityDetail.pismoAccountDetails.creation_date).format('DD/MM/YYYY')}}</div>
              </div>
              @if (latestRenewal && latestRenewal.RenewalDate) {
                <mat-divider></mat-divider>
                <div class="row pismo-account-details">
                  <div class="col-lg-3 col-md-12 title">Latest Renewal Date</div>
                  <div class="col-lg-6 col-md-12">{{moment(latestRenewal.RenewalDate).format('DD/MM/YYYY')}}</div>
                </div>
              }
              <mat-divider></mat-divider>
              <div class="row pismo-account-details">
                <div class="col-lg-3 col-md-12 title">Total Limit</div>
                <div class="col-lg-6 col-md-12">{{pismoAccountAndOpportunityDetail.pismoAccountDetails.total_credit_limit | looseCurrency}}</div>
              </div>
              <mat-divider></mat-divider>
              <div class="row pismo-account-details">
                <div class="col-lg-3 col-md-12 title">Current Balance</div>
                <div class="col-lg-6 col-md-12">{{pismoAccountAndOpportunityDetail.pismoAccountDetails.current_balance | looseCurrency}}</div>
              </div>
              <mat-divider></mat-divider>
              <div class="row pismo-account-details">
                <div class="col-lg-3 col-md-12 title">Available Limit</div>
                <div class="col-lg-6 col-md-12">{{pismoAccountAndOpportunityDetail.pismoAccountDetails.available_limit | looseCurrency}}</div>
              </div>
              <mat-divider></mat-divider>
              <div class="row pismo-account-details">
                <div class="col-lg-3 col-md-12 title">Rate</div>
                @if (pismoAccountWithInterestRate.length) {
                  <div class="col-lg-6 col-md-12">
                    {{pismoAccountWithInterestRate[i].interestRate | number : '1.2-2' | percentage}}
                  </div>
                }
              </div>
              <mat-divider></mat-divider>
              <div class="row pismo-account-details">
                <div class="col-lg-3 col-md-12 title">Term</div>
                @if (pismoAccountAndOpportunityDetail.opportunityDetails?.Term) {
                  <div class="col-lg-6 col-md-12" >{{pismoAccountAndOpportunityDetail.opportunityDetails?.Term}} months</div>
                }
              </div>
              <mat-divider></mat-divider>
              <div class="row pismo-account-details">
                <div class="col-lg-3 col-md-12 title">Doc Fee</div>
                @if (pismoAccountAndOpportunityDetail.opportunityDetails?.DocFee !== undefined && pismoAccountAndOpportunityDetail.opportunityDetails?.DocFee !== null) {
                  <div class="col-lg-6 col-md-12">
                    {{pismoAccountAndOpportunityDetail.opportunityDetails?.DocFee | looseCurrency}}
                  </div>
                }
              </div>
              <mat-divider></mat-divider>
              <div class="row pismo-account-details">
                <div class="col-lg-3 col-md-12 title">Doc Fee Financed</div>
                <div class="col-lg-6 col-md-12">
                  @if (pismoAccountAndOpportunityDetail.opportunityDetails?.DocFeeFinanced) {
                    Yes
                  }
                  @if (!pismoAccountAndOpportunityDetail.opportunityDetails?.DocFeeFinanced) {
                    No
                  }
                </div>
              </div>
              <mat-divider></mat-divider>
              <div class="row pismo-account-details">
                <div class="col-lg-3 col-md-12 title">Monthly Facility Fee</div>
                <div class="col-lg-6 col-md-12">{{pismoAccountAndOpportunityDetail.monthlyFacilityFee | looseCurrency}}</div>
              </div>
              <mat-divider></mat-divider>
              <div class="row pismo-account-details">
                <div class="col-lg-3 col-md-12 title">Monthly Facility Fee%</div>
                <div class="col-lg-6 col-md-12">
                  {{(pismoAccountAndOpportunityDetail.pismoAccountDetails.custom_fields.monthlyFacilityFeePercentage ?? 0) | number : '1.2-2' | percentage}}
                  @if (canEdit) {
                    <button mat-flat-button
                      [disabled]="!canEdit"
                      class="inactive retry-button"
                      (click)="updateMonthlyFacilityFeePercentage(pismoAccountAndOpportunityDetail)">
                      <span class="mdi mdi-pencil-outline"></span>
                    </button>
                  }
                </div>
              </div>
              <mat-divider></mat-divider>
              <div class="row pismo-account-details">
                <div class="col-lg-3 col-md-12 title">Payment Limit</div>
                <div class="col-lg-6 col-md-12">
                  <editable>
                    <ng-template editMode>
                      <div fxLayout="row" fxLayoutAlign="space-between" fxLayoutGap="5px">
                        <currency-input
                          [formControl]="pismoAccountAndOpportunityDetail.formControlPaymentLimit">
                        </currency-input>
                        <button mat-flat-button
                                editableOnSave
                                (click)="saveOverdraftPaymentLimit($event, pismoAccountAndOpportunityDetail)"
                                [disabled]="!canEdit || pismoAccountAndOpportunityDetail.formControlPaymentLimit.invalid">
                          Save
                        </button>
                        @if (loader.paymentLimitUpdated.inProgress$ | async) {
                          <span>Updating ...</span>
                        }
                      </div>
                      @for (errorKey of errorKeys(pismoAccountAndOpportunityDetail.formControlPaymentLimit); track errorKey) {
                        <mat-error>
                          @if (pismoAccountAndOpportunityDetail.formControlPaymentLimit.touched && pismoAccountAndOpportunityDetail.formControlPaymentLimit.hasError(errorKey)) {
                            {{errorMessage(pismoAccountAndOpportunityDetail.formControlPaymentLimit, errorKey)}}
                          }
                        </mat-error>
                      }
                    </ng-template>
                    <ng-template viewMode>
                      {{(pismoAccountAndOpportunityDetail.pismoAccountDetails.custom_fields.paymentLimit ? pismoAccountAndOpportunityDetail.pismoAccountDetails.custom_fields.paymentLimit : 0) | looseCurrency}}
                      @if (canEdit) {
                        <span class="mdi mdi-pencil-outline" matTooltip="Edit Payment Limit"></span>
                        @if (loader.paymentLimitUpdated.inProgress$ | async) {
                          <span>Updating ...</span>
                        }
                      }
                    </ng-template>
                  </editable>
                </div>
              </div>
              <mat-divider></mat-divider>
              <div class="row pismo-account-details">
                <div class="col-lg-3 col-md-12 title">Require Fixed Monthly Installment</div>
                <div class="col-lg-6 col-md-12">
                  {{!!getPismoAccountMapping(pismoAccountAndOpportunityDetail.pismoAccountDetails.account_id)?.requireMonthlyFixedInstallment ? 'Yes' : 'No'}}
                  @if (canEdit) {
                     <button mat-flat-button
                        [disabled]="!canEdit"
                        class="inactive retry-button"
                        (click)="updateRequireMonthlyFixedInstallmentFlag(pismoAccountAndOpportunityDetail.pismoAccountDetails.account_id)">
                        <span class="mdi mdi-pencil-outline"></span>
                      </button>
                    }
                </div>
              </div>
              @if (!!getPismoAccountMapping(pismoAccountAndOpportunityDetail.pismoAccountDetails.account_id)?.requireMonthlyFixedInstallment) {
                <mat-divider></mat-divider>
                <div class="row pismo-account-details">
                  <div class="col-lg-3 col-md-12 title">Monthly Repayment</div>
                  <div class="col-lg-6 col-md-12">
                    {{pismoAccountAndOpportunityDetail.pismoAccountDetails.custom_fields.repayment ?? 0 | looseCurrency}}
                    @if (canEdit) {
                        <button mat-flat-button
                          [disabled]="!canEdit"
                          class="inactive retry-button"
                          (click)="updateAmortisedRepayment(pismoAccountAndOpportunityDetail)">
                          <span class="mdi mdi-pencil-outline"></span>
                        </button>
                      }
                  </div>        
                </div>
              }
            <mat-divider></mat-divider>
            <div class="row pismo-account-details">
              <div class="col-lg-3 col-md-12 title">Stop Direct Debit</div>
              <div class="col-lg-6 col-md-12">
                
                {{!!getPismoAccountMapping(pismoAccountAndOpportunityDetail.pismoAccountDetails.account_id)?.stopDirectDebit ? 'Yes' : 'No'}}
                @if (canEdit) {
                   <button mat-flat-button
                    class="inactive retry-button"
                    (click)="updateStopDirectDebitFlag(pismoAccountAndOpportunityDetail.pismoAccountDetails.account_id)">
                    <span class="mdi mdi-pencil-outline"></span>
                  </button>
                }
              </div>
            </div>
            <mat-divider></mat-divider>


            <div class="row pismo-account-details mb-2">
              <div class="col-12 section">Account Setup Fees</div>
            </div>
            <mat-divider></mat-divider>
            <div class="row pismo-account-details">
              <div class="col-lg-3 col-md-12 title">Facility Establishment Fee</div>
              <div class="col-lg-6 col-md-12">
                <!-- Facility Establishment Fee -->
                @if (getPismoAccountMapping(pismoAccountAndOpportunityDetail.pismoAccountDetails.account_id)?.facilityEstablishmentFeeStatus) {
                  Posted Success
                }
                @if (!getPismoAccountMapping(pismoAccountAndOpportunityDetail.pismoAccountDetails.account_id)?.facilityEstablishmentFeeStatus) {
                  Failed
                  @if (canEdit) {
                    <button mat-flat-button
                      [disabled]="!canEdit"
                      class="retry-button"
                      (click)="retryFacilityEstablishmentFee(pismoAccountAndOpportunityDetail.pismoAccountDetails)">
                      <span class="mdi mdi-refresh"></span>Retry
                    </button>
                  }
                }
              </div>
            </div>
            <div class="row pismo-account-details">
              <div class="col-lg-3 col-md-12 title">Brokerage</div>
              <!-- Brokerage -->
              <div class="col-lg-6 col-md-12">
                @if (getPismoAccountMapping(pismoAccountAndOpportunityDetail.pismoAccountDetails.account_id)?.brokerageStatus) {
                  Posted Success
                }
                @if (!getPismoAccountMapping(pismoAccountAndOpportunityDetail.pismoAccountDetails.account_id)?.brokerageStatus) {
                  Failed
                  @if (canEdit) {  
                  <button mat-flat-button
                    [disabled]="!canEdit"
                    class="inactive retry-button"
                    (click)="retryBrokerage(pismoAccountAndOpportunityDetail.pismoAccountDetails)">
                    <span class="mdi mdi-refresh"></span>Retry
                  </button>
                }
              }
              </div>
            </div>
            <div class="row pismo-account-details">
              <div class="col-lg-3 col-md-12 title">Documentation Fee</div>
              <!-- Documentation Fee -->
              <div class="col-lg-6 col-md-12">
                @if (getPismoAccountMapping(pismoAccountAndOpportunityDetail.pismoAccountDetails.account_id)?.documentationFeeStatus) {
                  Posted Success
                }
                @if (!getPismoAccountMapping(pismoAccountAndOpportunityDetail.pismoAccountDetails.account_id)?.documentationFeeStatus) {
                  Failed
                  @if (canEdit) {  
                    <button mat-flat-button
                      [disabled]="!canEdit"
                      class="inactive retry-button"
                      (click)="retryDocumentationFee(pismoAccountAndOpportunityDetail.pismoAccountDetails)">
                      <span class="mdi mdi-refresh"></span>Retry
                    </button>
                  }
                }
              </div>
            </div>
            <!-- Documentation Fee Reversal -->
            @if (!pismoAccountAndOpportunityDetail.opportunityDetails?.DocFeeFinanced) {
              <div class="row pismo-account-details">
                <div class="col-lg-3 col-md-12 title" >Documentation Fee Reversal</div>
                <div class="col-lg-6 col-md-12">
                  @if (getPismoAccountMapping(pismoAccountAndOpportunityDetail.pismoAccountDetails.account_id)?.documentationFeeReversalStatus) {
                    Posted Success
                  }
                  @if (!getPismoAccountMapping(pismoAccountAndOpportunityDetail.pismoAccountDetails.account_id)?.documentationFeeReversalStatus) {
                    Failed
                    @if (canEdit) {
                      <button mat-flat-button
                        [disabled]="!canEdit"
                        class="inactive retry-button"
                        (click)="retryDocumentationFeeReversal(pismoAccountAndOpportunityDetail.pismoAccountDetails)">
                        <span class="mdi mdi-refresh"></span>Retry
                      </button>
                    }
                  }
                </div>
              </div>
            }
            <!-- Account Interest Rate -->
            <div class="row pismo-account-details">
              <div class="col-lg-3 col-md-12 title">Account Interest Rate Setup</div>
              <div class="col-lg-6 col-md-12">
                @if (getPismoAccountMapping(pismoAccountAndOpportunityDetail.pismoAccountDetails.account_id)?.saveAccountInterestRateStatus) {
                  Posted Success
                }
                @if (!getPismoAccountMapping(pismoAccountAndOpportunityDetail.pismoAccountDetails.account_id)?.saveAccountInterestRateStatus) {
                  Failed
                  @if (canEdit) {  
                    <button mat-flat-button
                      class="inactive retry-button"
                      [disabled]="!canEdit"
                      (click)="retryAccountInterestRate(pismoAccountAndOpportunityDetail.pismoAccountDetails)">
                      <span class="mdi mdi-refresh"></span>Retry
                    </button>
                  }
                }
              </div>
            </div>
            <!-- Transferred Balance -->
            <div class="row pismo-account-details mb-2">
              <div class="col-lg-3 col-md-12 title">Transferred Balance</div>
              <div class="col-lg-6 col-md-12">
                @if (getPismoAccountMapping(pismoAccountAndOpportunityDetail.pismoAccountDetails.account_id)?.postBalanceStatus) {
                  Posted Success
                }
                @if (!getPismoAccountMapping(pismoAccountAndOpportunityDetail.pismoAccountDetails.account_id)?.postBalanceStatus) {
                  No Balance or Post Failed
                  @if (canEdit) {  
                    <button mat-flat-button
                      [disabled]="!canEdit"
                      class="inactive retry-button"
                      (click)="retryTransferredBalance(pismoAccountAndOpportunityDetail.pismoAccountDetails)">
                      <span class="mdi mdi-refresh"></span>Retry
                    </button>
                  }
                }
              </div>
            </div>
            <mat-divider></mat-divider>

            <!-- Latest Limit Change Section -->
            @if (latestLimitChange) {
              <div class="row pismo-account-details mb-2">
                <div class="col-12 section" fxLayout="row" fxLayoutAlign="space-between center">
                  <span>Latest Limit Change ({{latestLimitChange.ChangeType | titlecase}})</span>
                  @if (!showHistoricalLimitChanges) {
                    <button mat-stroked-button (click)="loadHistoricalLimitChanges()">
                      Load Historical Data
                    </button>
                  }
                </div>
              </div>
              <mat-divider></mat-divider>
              <div class="row pismo-account-details">
                <div class="col-lg-3 col-md-12 title">Old Limit</div>
                <div class="col-lg-6 col-md-12">{{latestLimitChange.OldLimit | looseCurrency}}</div>
              </div>
              <mat-divider></mat-divider>
              <div class="row pismo-account-details">
                <div class="col-lg-3 col-md-12 title">New Limit</div>
                <div class="col-lg-6 col-md-12">{{latestLimitChange.NewLimit | looseCurrency}}</div>
              </div>
              <mat-divider></mat-divider>

              <!-- Failed Operations for Limit Change -->
              @if (latestLimitChange.PostBrokerage === false && latestLimitChange.Brokerage) {
                <div class="row pismo-account-details">
                  <div class="col-lg-3 col-md-12 title">Brokerage</div>
                  <div class="col-lg-6 col-md-12">
                    Failed
                    @if (canEdit) {
                      <button mat-flat-button class="retry-button" 
                        (click)="retryAccountChangeOperation(latestLimitChange.Id, 'brokerage', latestLimitChange.PismoAccountNumber, latestLimitChange.Brokerage)">
                        <span class="mdi mdi-refresh"></span>Retry
                      </button>
                    }
                  </div>
                </div>
                <mat-divider></mat-divider>
              }

              @if (latestLimitChange.PostFacilityEstablishmentFee === false && latestLimitChange.FacilityEstablishmentFee) {
                <div class="row pismo-account-details">
                  <div class="col-lg-3 col-md-12 title">Facility Establishment Fee</div>
                  <div class="col-lg-6 col-md-12">
                    Failed
                    @if (canEdit) {
                      <button mat-flat-button class="retry-button" 
                        (click)="retryAccountChangeOperation(latestLimitChange.Id, 'facility establishment fee', latestLimitChange.PismoAccountNumber, latestLimitChange.FacilityEstablishmentFee)">
                        <span class="mdi mdi-refresh"></span>Retry
                      </button>
                    }
                  </div>
                </div>
                <mat-divider></mat-divider>
              }

              @if (latestLimitChange.PostDocumentationFee === false && latestLimitChange.DocumentationFee) {
                <div class="row pismo-account-details">
                  <div class="col-lg-3 col-md-12 title">Documentation Fee</div>
                  <div class="col-lg-6 col-md-12">
                    Failed
                    @if (canEdit) {
                      <button mat-flat-button class="retry-button" 
                        (click)="retryAccountChangeOperation(latestLimitChange.Id, 'documentation fee', latestLimitChange.PismoAccountNumber, latestLimitChange.DocumentationFee)">
                        <span class="mdi mdi-refresh"></span>Retry
                      </button>
                    }
                  </div>
                </div>
                <mat-divider></mat-divider>
              }

              @if (latestLimitChange.PostDocumentationFeeReversal === false && latestLimitChange.DocumentationFee) {
                <div class="row pismo-account-details">
                  <div class="col-lg-3 col-md-12 title">Documentation Fee Reversal</div>
                  <div class="col-lg-6 col-md-12">
                    Failed
                    @if (canEdit) {
                      <button mat-flat-button class="retry-button" 
                        (click)="retryAccountChangeOperation(latestLimitChange.Id, 'documentation fee reversal', latestLimitChange.PismoAccountNumber, latestLimitChange.DocumentationFee)">
                        <span class="mdi mdi-refresh"></span>Retry
                      </button>
                    }
                  </div>
                </div>
                <mat-divider></mat-divider>
              }

              @if (latestLimitChange.PostEarlyTerminationFee === false && latestLimitChange.EarlyTerminationFee) {
                <div class="row pismo-account-details">
                  <div class="col-lg-3 col-md-12 title">Early Termination Fee</div>
                  <div class="col-lg-6 col-md-12">
                    Failed
                    @if (canEdit) {
                      <button mat-flat-button class="retry-button" 
                        (click)="retryAccountChangeOperation(latestLimitChange.Id, 'early termination fee', latestLimitChange.PismoAccountNumber, latestLimitChange.EarlyTerminationFee)">
                        <span class="mdi mdi-refresh"></span>Retry
                      </button>
                    }
                  </div>
                </div>
                <mat-divider></mat-divider>
              }

              @if (latestLimitChange.SaveAccountInterestRate === false) {
                <div class="row pismo-account-details">
                  <div class="col-lg-3 col-md-12 title">Account Interest Rate</div>
                  <div class="col-lg-6 col-md-12">
                    Failed
                    @if (canEdit) {
                      <button mat-flat-button class="retry-button" 
                        (click)="retryAccountChangeOperation(latestLimitChange.Id, 'account interest rate', latestLimitChange.PismoAccountNumber, undefined, { margin: latestLimitChange.Margin })">
                        <span class="mdi mdi-refresh"></span>Retry
                      </button>
                    }
                  </div>
                </div>
                <mat-divider></mat-divider>
              }

              <!-- Historical Limit Changes -->
              @if (showHistoricalLimitChanges && historicalLimitChanges.length > 1) {
                <div class="row pismo-account-details mb-2">
                  <div class="col-12 section">Historical Limit Changes</div>
                </div>
                @for (change of historicalLimitChanges.slice(1); track change.Id) {
                  <mat-divider></mat-divider>
                  <div class="row pismo-account-details">
                    <div class="col-lg-3 col-md-12 title">{{change.ChangeType | titlecase}} - {{moment(change.LastUpdatedTime).format('DD/MM/YYYY')}}</div>
                    <div class="col-lg-6 col-md-12">{{change.OldLimit | looseCurrency}} → {{change.NewLimit | looseCurrency}}</div>
                  </div>
                }
              }
            }

            <!-- Latest Renewal Section -->
            @if (latestRenewal) {
              <div class="row pismo-account-details mb-2">
                <div class="col-12 section" fxLayout="row" fxLayoutAlign="space-between center">
                  <span>Latest Renewal</span>
                  @if (!showHistoricalRenewals) {
                    <button mat-stroked-button (click)="loadHistoricalRenewals()">
                      Load Historical Data
                    </button>
                  }
                </div>
              </div>
              <mat-divider></mat-divider>
              <div class="row pismo-account-details">
                <div class="col-lg-3 col-md-12 title">Renewal Date</div>
                <div class="col-lg-6 col-md-12">
                  @if (latestRenewal.RenewalDate) {
                    {{moment(latestRenewal.RenewalDate).format('DD/MM/YYYY')}}
                  } @else {
                    -
                  }
                </div>
              </div>
              <mat-divider></mat-divider>

              <!-- Failed Operations for Renewal -->
              @if (latestRenewal.PostBrokerage === false && latestRenewal.Brokerage) {
                <div class="row pismo-account-details">
                  <div class="col-lg-3 col-md-12 title">Brokerage</div>
                  <div class="col-lg-6 col-md-12">
                    Failed
                    @if (canEdit) {
                      <button mat-flat-button class="retry-button" 
                        (click)="retryAccountChangeOperation(latestRenewal.Id, 'brokerage', latestRenewal.PismoAccountNumber, latestRenewal.Brokerage)">
                        <span class="mdi mdi-refresh"></span>Retry
                      </button>
                    }
                  </div>
                </div>
                <mat-divider></mat-divider>
              }

              @if (latestRenewal.PostFacilityEstablishmentFee === false && latestRenewal.FacilityEstablishmentFee) {
                <div class="row pismo-account-details">
                  <div class="col-lg-3 col-md-12 title">Facility Establishment Fee</div>
                  <div class="col-lg-6 col-md-12">
                    Failed
                    @if (canEdit) {
                      <button mat-flat-button class="retry-button" 
                        (click)="retryAccountChangeOperation(latestRenewal.Id, 'facility establishment fee', latestRenewal.PismoAccountNumber, latestRenewal.FacilityEstablishmentFee)">
                        <span class="mdi mdi-refresh"></span>Retry
                      </button>
                    }
                  </div>
                </div>
                <mat-divider></mat-divider>
              }

              @if (latestRenewal.PostDocumentationFee === false && latestRenewal.DocumentationFee) {
                <div class="row pismo-account-details">
                  <div class="col-lg-3 col-md-12 title">Documentation Fee</div>
                  <div class="col-lg-6 col-md-12">
                    Failed
                    @if (canEdit) {
                      <button mat-flat-button class="retry-button" 
                        (click)="retryAccountChangeOperation(latestRenewal.Id, 'documentation fee', latestRenewal.PismoAccountNumber, latestRenewal.DocumentationFee)">
                        <span class="mdi mdi-refresh"></span>Retry
                      </button>
                    }
                  </div>
                </div>
                <mat-divider></mat-divider>
              }

              @if (latestRenewal.PostDocumentationFeeReversal === false && latestRenewal.DocumentationFee) {
                <div class="row pismo-account-details">
                  <div class="col-lg-3 col-md-12 title">Documentation Fee Reversal</div>
                  <div class="col-lg-6 col-md-12">
                    Failed
                    @if (canEdit) {
                      <button mat-flat-button class="retry-button" 
                        (click)="retryAccountChangeOperation(latestRenewal.Id, 'documentation fee reversal', latestRenewal.PismoAccountNumber, latestRenewal.DocumentationFee)">
                        <span class="mdi mdi-refresh"></span>Retry
                      </button>
                    }
                  </div>
                </div>
                <mat-divider></mat-divider>
              }

              @if (latestRenewal.PostEarlyTerminationFee === false && latestRenewal.EarlyTerminationFee) {
                <div class="row pismo-account-details">
                  <div class="col-lg-3 col-md-12 title">Early Termination Fee</div>
                  <div class="col-lg-6 col-md-12">
                    Failed
                    @if (canEdit) {
                      <button mat-flat-button class="retry-button" 
                        (click)="retryAccountChangeOperation(latestRenewal.Id, 'early termination fee', latestRenewal.PismoAccountNumber, latestRenewal.EarlyTerminationFee)">
                        <span class="mdi mdi-refresh"></span>Retry
                      </button>
                    }
                  </div>
                </div>
                <mat-divider></mat-divider>
              }

              @if (latestRenewal.SaveAccountInterestRate === false) {
                <div class="row pismo-account-details">
                  <div class="col-lg-3 col-md-12 title">Account Interest Rate</div>
                  <div class="col-lg-6 col-md-12">
                    Failed
                    @if (canEdit) {
                      <button mat-flat-button class="retry-button" 
                        (click)="retryAccountChangeOperation(latestRenewal.Id, 'account interest rate', latestRenewal.PismoAccountNumber, undefined, { margin: latestRenewal.Margin })">
                        <span class="mdi mdi-refresh"></span>Retry
                      </button>
                    }
                  </div>
                </div>
                <mat-divider></mat-divider>
              }

              <!-- Historical Renewals -->
              @if (showHistoricalRenewals && historicalRenewals.length > 1) {
                <div class="row pismo-account-details mb-2">
                  <div class="col-12 section">Historical Renewals</div>
                </div>
                @for (renewal of historicalRenewals.slice(1); track renewal.Id) {
                  <mat-divider></mat-divider>
                  <div class="row pismo-account-details">
                    <div class="col-lg-3 col-md-12 title">{{moment(renewal.LastUpdatedTime).format('DD/MM/YYYY')}}</div>
                    <div class="col-lg-6 col-md-12">
                      @if (renewal.RenewalDate) {
                        Renewed on {{moment(renewal.RenewalDate).format('DD/MM/YYYY')}}
                      } @else {
                        Renewed
                      }
                    </div>
                  </div>
                }
              }
            }
          </mat-expansion-panel>
        }
      </mat-accordion>
    </div>
  </div>
}